module.exports = __webpack_public_path__ + "static/media/rw-widgets.57cea767.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/react-widgets/fonts/rw-widgets.svg
// module id = 334
// module chunks = 0